import { env } from './_bootstrap';
import authorMode from '../Constants/Constants';

export { env };

export const locale = ((window.sharedEnvConfig && window.sharedEnvConfig.language) || document.documentElement.lang || 'en-us').toLowerCase();

const isZhCn = () => (locale === 'zh-cn' ? 'zh-hans' : locale);
const isChinese = () => (locale === 'zh-tw' ? 'zh-hant' : isZhCn());

export const language = isChinese();

export const authorPath = '/content/minecraft-net/language-masters/' + language + '/';

export function baseRoute(url: string) {
  const route = authorMode ? `${authorPath}/${language}/` : `/${language}/`;
  return route + url;
}
export function updateSelectedNav(url: string) {
  window.parent.location.href = baseRoute(url);
}

export const sharedEnvConfig = {
  currency: '',
  language,
  locale,
  'cookie.name': 'bearer_token',
  'cookie.options': {
    domain: '.minecraft.net',
    secure: true
  },
  'enable.dungeonsPreorder': false,
  'enable.msa': true,
  'enable.msaMigration': false,
  'url.forgotPassword': window.location.origin + '/' + language + '/password/forgot/',
  'url.homePage': window.location.origin + '/',
  'url.login': window.location.origin + '/' + language + '/login',
  'url.profile': window.location.origin + '/' + language + '/profile',
  'cookie.entitlementState': 'hasMcJavaEntitlement',
  msaStateLoginParam: 'login',
  'url.supportCenter': 'https://help.mojang.com/',
  'minecraft.entitlements': ['product_minecraft', 'game_minecraft'],
  'url.xboxLogoutReturnUrl': window.location.origin + '/' + language,
  /* eslint-disable */
  'url.imageBaseUrl': __webpack_public_path__ + 'assets',
  titleId: '896928775',
  sisuAppId: '1142970254',
  /**for console errors*/
  'endpoint.arkose': 'https://minecraft-api.arkoselabs.com/',
  'url.orderSummary': '',
  'url.supportCenterforMSAMigration': 'https://help.minecraft.net/hc/en-us/sections/360011399911-Migration-for-Minecraft-Java-Edition',
  translationPath: '',
  'url.windows1011OsLauncher': 'https://launcher.mojang.com/download/MinecraftInstaller.exe',
  deleteNonEssentialCookie: false,
  nonEssentialCookies: ['_cs_id', '_cs_cvars', 'MicrosoftApplicationsTelemetryDeviceId', 'at_check', '_cs_c'],
  'realms.plans': [],
  'url.forcedBillingInfo': '',
  'enable.showEditWorldLink': false,
  'toggle.OneStoreWallet.setProfileName.Flow': true
} as const;

export const accountNavMenuConfig = {} as const;

export const answerSecurityQuestionsConfig = {} as const;

export const bundleConfig = {} as const;

export const msaUtilsConfig = {
  relyingPartyKey: 'rp://api.minecraftservices.com/',
  'url.xboxLoginReturnUrl': window.location.origin + '/' + language + '/login',
  'url.xboxRegisterReturnUrl': window.location.origin + '/' + language + '/login',
  'url.xboxLiveUrl': 'xboxlive.com',
  'url.plafabXboxLiveUrl': 'playfab.xboxlive.com/',
  'url.marketplaceMinecraft': 'mp.microsoft.com/',
  'url.pocketRelamsMinecraft': 'pocket.realms.minecraft.net/',
  sisuCobrandId: '8058f65d-ce06-4c30-9559-473c9275a65d',
  xboxMSAClientId: 'ca634a9a-f102-4033-b081-3a4393a6f65d'
} as const;

export const buyMinecraftLoginConfig = {
  'endpoint.pdpUrl': window.location.origin + '/' + language + '/store/minecraft-java-edition',
  variantId: 'minecraft',
  'url.purchaseReciept': window.location.origin + '/' + language + '/msaprofile/redeem',
  'url.xboxPurchaseLoginReturnUrl': `${window.location.origin}/${language}/store/minecraft-java-edition/buy`
} as const;

export const cartStoreConfig = {
  countryCode: language
} as const;

export const loginConfig = {} as const;

export const logoutConfig = {
  'url.postLogout': window.location.origin + '/' + language + '/'
} as const;

export const msaMigrationConfig = {
  cobrandId: 'fb937bf5-b9a1-4b61-b744-82f9a1adc248',
  'url.securityView': `${window.location.origin}/${language}/account-security`,
  'url.supportCenter': 'https://help.mojang.com/',
  'url.windowsOsLauncher': 'https://launcher.mojang.com/download/MinecraftInstaller.msi',
  'url.distributionLauncher': 'https://www.minecraft.net/en-us/download/alternative',
  'url.MacOsLauncher': 'https://launcher.mojang.com/download/Minecraft.dmg',
  'url.debianUbuntuLauncher': 'https://launcher.mojang.com/download/Minecraft.deb',
  'endpoint.migrationValidate': 'migration/validate',
  'name.service': 'MinecraftServices',
  'instrumentation.key': 'c0570cc3b05346d790b276b2c1355300-48dbf180-31ea-40ce-a720-e2d3c833be38-6824',
  'analytics.apiName': 'Ms.Web.ApiPerf'
} as const;

export const msaRegistrationConfig = {} as const;

export const orderSummaryConfig = {} as const;

export const passwordChangeConfig = {} as const;

export const passwordForgotConfig = {
  'url.emailHelpArticle': 'https://help.mojang.com/customer/portal/articles/542001',
  'url.forgotPasswordHelpArticle': 'https://help.minecraft.net/hc/en-us/articles/360035014051-Change-or-Forgot-Password'
} as const;

export const passwordResetConfig = {} as const;

export const profileConfig = {
  'url.realmsEulaUrl': 'https://account.mojang.com/documents/desktop_realms_terms',
  'url.realmsMarketingPage': 'https://aka.ms/MinecraftNetRealmsJava',
  'url.privacyPolicyUrl': 'https://go.microsoft.com/fwlink/?LinkId=521839',
  'asset.themeModelClassic': __webpack_public_path__ + 'static/theme/freyja/svg/shapes/shape-model-classic.svg',
  'asset.themeModelSlim': __webpack_public_path__ + 'static/theme/freyja/svg/shapes/shape-model-slim.svg',
  'enable.asq': true
} as const;

export const profileRedeemCodeConfig = {
  'url.login': `${window.location.origin}/${language}/login`,
  'url.eula': 'https://aka.ms/MinecraftEULA',
  'minecraft.products': {
    display_name: 'MineCraft: Java Edition'
  },
  'url.minecraftRedeem': `${window.location.origin}/${language}/redeem`,
  productVariant: 'minecraft'
} as const;

export const setProfileNameConfig = {} as const;
